import { QueryOptions } from '../../components/Common/useQuery';
import useUserOrEmployeeQuery from '../../components/Common/useUserOrEmployeeQuery';
import { useUserOrKaEmployee } from '../../components/UserAccess/useUserOrKaEmployee';

export interface FieldAlyticsSettings {
  fieldAlyticsUsername: string;
}

const useGetFieldAlyticsSettings = (options?: QueryOptions<FieldAlyticsSettings>) => {
  const { selectedBusiness } = useUserOrKaEmployee();
  return useUserOrEmployeeQuery<FieldAlyticsSettings>(
    { path: `/api/integrations/fieldalytics/${selectedBusiness?.id}/settings` },
    { ...options, rewriteToEmployeeApi: false }
  );
};

export default useGetFieldAlyticsSettings;
